import TemplateEditCreateForm from "../template-form";

export const CreateTemplate = () => {
  return <TemplateEditCreateForm />;
};

export default CreateTemplate;
